import type { IconSvgObject } from './types';

const XIcon: IconSvgObject = [
  ["path", { d: "M18 6L12 12M12 12L6 18M12 12L18 18M12 12L6 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default XIcon;
